import styled from 'styled-components';

import { cardBackround } from '@/styles/shared';

export const ContactFormWrapper = styled.div`
  ${cardBackround};
  padding: 20px;
`;
